import { render, staticRenderFns } from "./add-channel-form-PRO.vue?vue&type=template&id=c11ebe62&"
import script from "./add-channel-form-PRO.vue?vue&type=script&lang=ts&"
export * from "./add-channel-form-PRO.vue?vue&type=script&lang=ts&"
import style0 from "./add-channel-form-PRO.vue?vue&type=style&index=0&id=c11ebe62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports